import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';

/**
 * Fetches the app configuration from the server.
 *
 * @return Promise<ChalkySticks.Model.AppConfig>
 */
export async function fetchConfig(): Promise<ChalkySticks.Model.AppConfig> {
	const configModel = new ChalkySticks.Model.AppConfig();

	try {
		// Fetch settings from the server
		await configModel.fetch();

		// Dispatch global event with configuration
		ChalkySticks.Core.Event.Bus.dispatch('app.config', configModel.attributes);

		// Update the local store settings
		Store.dispatch('settings/updateConfig', configModel.attributes);

		// Log
		ChalkySticks.Utility.Log.info('app:config', 'Config fetched.', configModel.attributes);
	} catch (e: any) {
		console.warn('No settings available', e);
	}

	return configModel;
}
